//

/* 
https://i.ibb.co/Fg3kDC2/4-a.jpg
https://i.ibb.co/7kcRT6r/4.png
*/

export const dummyPosts = [
	{
		img: 'https://i.ibb.co/yXQWk4r/1.jpg',
		author: 'Dr. Raka Mustary Khan',
		authorImg: 'https://i.ibb.co/N6YfnmC/1-a.jpg',
		authorBio: 'General Surgeon',
		time: '3h',
		content: 'পিত্তথলির পাথরের লক্ষণগুলি জেনে নিন..',
		reactorName: 'Dr. Belal Hossen',
	},
	{
		img: 'https://i.ibb.co/7kcRT6r/4.png',
		author: 'Square Pharmaceuticals Ltd. Bangladesh',
		authorImg: 'https://i.ibb.co/Fg3kDC2/4-a.jpg',
		authorBio:
			'Square Pharmaceuticals is the largest pharmaceutical company in Bangladesh',
		time: '1D',
		content: '',
		reactorName: 'Raka Mustary',
	},
	{
		img: '',
		author: 'Shahin Ferdous',
		authorBio: 'Sunshine Nutrition and health research center, California',
		authorImg: 'https://i.ibb.co/xY82FJ7/2-a.jpg',
		content:
			'বিশ্বের বড় বড় ঔষধ কোম্পানিগুলো কম দামি কিন্তু মহাকার্যকর ঔষধগুলোর গবেষণা এড়িয়ে যায়। এই যেমন সব ধরনের Anti parasitic এবং কৃমি নাশক ঔষধগুলো ক‍্যান্সারে মহাকার্যকর। এগুলো ক‍্যান্সার কোষের খাবার গ্রহণের প্রক্রিয়া রুদ্ধ করে cancer এর stem cell কে সমূলে নির্মূল করতে সাহায্য করে। অথচ এগুলো খুবই সস্তা\nবহুজাতিক ঔষধ কোম্পানিগুলো চায় না ভিটামিন D এবং Ivermectin এ দুরারোগ‍্য ব‍্যাধি ভাল হোক। তারা গবেষণাগুলো এড়িয়ে চলে। কারণ কম টাকায় রোগ ভাল হলে এত ঔষধ কাকে গিলাবে??!! সব নষ্টের মূলে বাণিজ্যিক স্বার্থ।\nপশ্চিমা ডাক্তারেরা গবেষণাগুলো কাজে লাগান। তারা শয়তানি চক্র ভাল করেই বুঝেন। কিন্তু ক্ষতিগ্রস্ত হয় তৃতীয় বিশ্বের দেশগুলো।\nডাক্তারেরা অবশ্যই চায় তার রোগীরা ভাল হোক। কারণ রোগী ভাল হলে আরো বেশি রোগী আসবে চিকিৎসা নিতে।\n\nIs albendazole an anticancer drug?\nInitially emerging as a widely used clinical anti-parasitic drug, albendazole has been increasingly recognised as an effective anti-cancer agent due to its outstanding advantage, i.e. low toxicity to normal cells but high effectiveness against parasites and some tumours.',
		time: '6h',
		reactorName: 'Dr. Rakibul Islam',
	},
	{
		img: 'https://i.ibb.co/dDz8JfG/3.jpg',
		author: 'Raka Mustary',
		authorImg: 'https://i.ibb.co/XpvfCVG/3-a.jpg',
		authorBio:
			'Assistant professor Surgery at Mh Samorita Medicle College & Hospital',
		time: '2D',
		content:
			'আলহামদুলিল্লাহ।  প্রথম রোযার বৃষ্টি ভেজা আবহাওয়ায় সুখবর পেলাম।\nগত জানুয়ারিতে কুয়ালালামপুরে দেয়া MRCS ফাইনাল পরীক্ষায় পাস করেছি!\nএখন চাইলে বিলাতি ডাক্তার হওয়া যাবে 🙂 ।\nযদিও বিলেত যাওয়ার সিদ্ধান্ত নেয়া কঠিন।\nবিশেষ করে বাচ্চা দেশে থাকলে দাদা দাদি, নানা -নানী, ফুফা -ফুফু, চাচা- চাচী ,মামা -মামী সব কাছে পায় সারাক্ষণ।  শুধু খালা পায় না। এইটা আবার বাচ্চার বাবার দুঃখ!\nতার কোন শ্যালিকা নেই!\nদেশের বাইরে গেলে বাচ্চা  একা একা বড় হতে হয়। দেখা যাক কপালে কি আছে।\nDr Raka Mustary Khan\nMBBS, MS (Surgery)\nMRCS (Edinburgh, UK)',
		reactorName: 'Harun Rashid',
	},
];

export const subNav1 = [
	{
		name: 'Psychologist',
		img: '/images/navdropdown/psychology.png',
	},
	{
		name: 'Sexologist & VD',
		img: '/images/navdropdown/sexology.png',
	},
	{
		name: 'Diabetes / Ebdocrinologist',
		img: '/images/navdropdown/diabetes.png',
	},
	{
		name: 'Chest',
		img: '/images/navdropdown/chest.png',
	},
	{
		name: 'Dermatologist',
		img: '/images/navdropdown/dermatology.png',
	},
	{
		name: 'Gastroenterologist',
		img: '/images/navdropdown/stomach.png',
	},
	{
		name: 'Cardiology',
		img: '/images/navdropdown/cardiology.png',
	},
	{
		name: 'ENT / Head & Neck',
		img: '/images/navdropdown/sore-throat.png',
	},
	{
		name: 'Child / Pediatric',
		img: '/images/navdropdown/pediatrics.png',
	},
	{
		name: 'Obs & Gynecology',
		img: '/images/navdropdown/uterus.png',
	},
	{
		name: 'Dietitian & Nutritionist',
		img: '/images/navdropdown/nutrition.png',
	},
	{
		name: 'Neuromedicine',
		img: '/images/navdropdown/neurology.png',
	},
	{
		name: 'General Physician',
		img: '/images/navdropdown/doctor.png',
	},
	{
		name: 'Orthopedic',
		img: '/images/navdropdown/orthopedics.png',
	},
	{
		name: 'Dentist',
		img: '/images/navdropdown/tooth.png',
	},
	{
		name: 'Ophthalmology',
		img: '/images/navdropdown/stethoscope.png',
	},
];

export const subNav2 = [
	{
		name: 'Mental Health',
		sub: ['Anxiety', 'Depression', 'Insomnia', 'Drug Addiction'],
	},
	{
		name: 'Skin & Hair Health',
		sub: ['Pimple & Skin Infection', 'Skin Allergy', 'Hair Loss'],
	},
	{
		name: 'Pain',
		sub: ['Migraine', 'Back & Joint Pain', 'Muscle & Sports Pain'],
	},
	{
		name: 'General Health',
		sub: ['Cold & Fever', 'Gastric & Vomiting', 'Defecation', 'Weak & Tired'],
	},
	{
		name: "Women's Health",
		sub: ['UTI', 'Mensuration', 'Birth Control', 'Infertility Care'],
	},
	{
		name: "Sex & men's health",
		sub: ['Erectile Dysfunction', 'Premature Ejaculation'],
	},
	{
		name: 'Heart & Diabetes',
		sub: ['Blood Pressure', 'Diabetes', 'Heart', 'Nutrition & Diet'],
	},
	{
		name: 'Others',
		sub: [
			'Child / Pediatric',
			'Chest & Asthma',
			'Dental',
			'Eye',
			'ENT / Head / Neck',
		],
	},
];

export const subNav3 = [
	{
		name: 'AI Assistant',
		sub: [],
	},
	{
		name: 'Cloud-based',
		sub: [
			'Healthcare solution',
			'Video Conference services',
			'Health data comparing',
		],
	},
	{
		name: 'Secure health data',
		sub: [],
	},
];

export const subNav4 = ['Diet & nutrition', 'Mental Health', 'Meditation'];

export const countryData = [
	{
		code: 'AD',
		name: 'Andorra',
	},
	{
		code: 'AE',
		name: 'United Arab Emirates',
	},
	{
		code: 'AF',
		name: 'Afghanistan',
	},
	{
		code: 'AG',
		name: 'Antigua and Barbuda',
	},
	{
		code: 'AI',
		name: 'Anguilla',
	},
	{
		code: 'AL',
		name: 'Albania',
	},
	{
		code: 'AM',
		name: 'Armenia',
	},
	{
		code: 'AO',
		name: 'Angola',
	},
	{
		code: 'AQ',
		name: 'Antarctica',
	},
	{
		code: 'AR',
		name: 'Argentina',
	},
	{
		code: 'AS',
		name: 'American Samoa',
	},
	{
		code: 'AT',
		name: 'Austria',
	},
	{
		code: 'AU',
		name: 'Australia',
	},
	{
		code: 'AW',
		name: 'Aruba',
	},
	{
		code: 'AX',
		name: 'Åland',
	},
	{
		code: 'AZ',
		name: 'Azerbaijan',
	},
	{
		code: 'BA',
		name: 'Bosnia and Herzegovina',
	},
	{
		code: 'BB',
		name: 'Barbados',
	},
	{
		code: 'BD',
		name: 'Bangladesh',
	},
	{
		code: 'BE',
		name: 'Belgium',
	},
	{
		code: 'BF',
		name: 'Burkina Faso',
	},
	{
		code: 'BG',
		name: 'Bulgaria',
	},
	{
		code: 'BH',
		name: 'Bahrain',
	},
	{
		code: 'BI',
		name: 'Burundi',
	},
	{
		code: 'BJ',
		name: 'Benin',
	},
	{
		code: 'BL',
		name: 'Saint Barthélemy',
	},
	{
		code: 'BM',
		name: 'Bermuda',
	},
	{
		code: 'BN',
		name: 'Brunei',
	},
	{
		code: 'BO',
		name: 'Bolivia',
	},
	{
		code: 'BQ',
		name: 'Bonaire',
	},
	{
		code: 'BR',
		name: 'Brazil',
	},
	{
		code: 'BS',
		name: 'Bahamas',
	},
	{
		code: 'BT',
		name: 'Bhutan',
	},
	{
		code: 'BV',
		name: 'Bouvet Island',
	},
	{
		code: 'BW',
		name: 'Botswana',
	},
	{
		code: 'BY',
		name: 'Belarus',
	},
	{
		code: 'BZ',
		name: 'Belize',
	},
	{
		code: 'CA',
		name: 'Canada',
	},
	{
		code: 'CC',
		name: 'Cocos Islands',
	},
	{
		code: 'CF',
		name: 'Central African Republic',
	},
	{
		code: 'CH',
		name: 'Switzerland',
	},
	{
		code: 'CI',
		name: 'Ivory Coast',
	},
	{
		code: 'CK',
		name: 'Cook Islands',
	},
	{
		code: 'CL',
		name: 'Chile',
	},
	{
		code: 'CM',
		name: 'Cameroon',
	},
	{
		code: 'CN',
		name: 'China',
	},
	{
		code: 'CO',
		name: 'Colombia',
	},
	{
		code: 'CR',
		name: 'Costa Rica',
	},
	{
		code: 'CU',
		name: 'Cuba',
	},
	{
		code: 'CV',
		name: 'Cape Verde',
	},
	{
		code: 'CW',
		name: 'Curacao',
	},
	{
		code: 'CX',
		name: 'Christmas Island',
	},
	{
		code: 'CY',
		name: 'Cyprus',
	},
	{
		code: 'CZ',
		name: 'Czech Republic',
	},
	{
		code: 'DE',
		name: 'Germany',
	},
	{
		code: 'DJ',
		name: 'Djibouti',
	},
	{
		code: 'DK',
		name: 'Denmark',
	},
	{
		code: 'DM',
		name: 'Dominica',
	},
	{
		code: 'DO',
		name: 'Dominican Republic',
	},
	{
		code: 'DZ',
		name: 'Algeria',
	},
	{
		code: 'EC',
		name: 'Ecuador',
	},
	{
		code: 'EE',
		name: 'Estonia',
	},
	{
		code: 'EG',
		name: 'Egypt',
	},
	{
		code: 'EH',
		name: 'Western Sahara',
	},
	{
		code: 'ER',
		name: 'Eritrea',
	},
	{
		code: 'ES',
		name: 'Spain',
	},
	{
		code: 'ET',
		name: 'Ethiopia',
	},
	{
		code: 'FI',
		name: 'Finland',
	},
	{
		code: 'FJ',
		name: 'Fiji',
	},
	{
		code: 'FK',
		name: 'Falkland Islands',
	},
	{
		code: 'FM',
		name: 'Micronesia',
	},
	{
		code: 'FO',
		name: 'Faroe Islands',
	},
	{
		code: 'FR',
		name: 'France',
	},
	{
		code: 'GA',
		name: 'Gabon',
	},
	{
		code: 'GB',
		name: 'United Kingdom',
	},
	{
		code: 'GD',
		name: 'Grenada',
	},
	{
		code: 'GE',
		name: 'Georgia',
	},
	{
		code: 'GF',
		name: 'French Guiana',
	},
	{
		code: 'GG',
		name: 'Guernsey',
	},
	{
		code: 'GH',
		name: 'Ghana',
	},
	{
		code: 'GI',
		name: 'Gibraltar',
	},
	{
		code: 'GL',
		name: 'Greenland',
	},
	{
		code: 'GM',
		name: 'Gambia',
	},
	{
		code: 'GN',
		name: 'Guinea',
	},
	{
		code: 'GP',
		name: 'Guadeloupe',
	},
	{
		code: 'GQ',
		name: 'Equatorial Guinea',
	},
	{
		code: 'GR',
		name: 'Greece',
	},
	{
		code: 'GT',
		name: 'Guatemala',
	},
	{
		code: 'GU',
		name: 'Guam',
	},
	{
		code: 'GW',
		name: 'Guinea-Bissau',
	},
	{
		code: 'GY',
		name: 'Guyana',
	},
	{
		code: 'HK',
		name: 'Hong Kong',
	},
	{
		code: 'HN',
		name: 'Honduras',
	},
	{
		code: 'HR',
		name: 'Croatia',
	},
	{
		code: 'HT',
		name: 'Haiti',
	},
	{
		code: 'HU',
		name: 'Hungary',
	},
	{
		code: 'ID',
		name: 'Indonesia',
	},
	{
		code: 'IE',
		name: 'Ireland',
	},
	{
		code: 'IL',
		name: 'Israel',
	},
	{
		code: 'IM',
		name: 'Isle of Man',
	},
	{
		code: 'IN',
		name: 'India',
	},
	{
		code: 'IO',
		name: 'British Indian Ocean Territory',
	},
	{
		code: 'IQ',
		name: 'Iraq',
	},
	{
		code: 'IR',
		name: 'Iran',
	},
	{
		code: 'IS',
		name: 'Iceland',
	},
	{
		code: 'IT',
		name: 'Italy',
	},
	{
		code: 'JE',
		name: 'Jersey',
	},
	{
		code: 'JM',
		name: 'Jamaica',
	},
	{
		code: 'JO',
		name: 'Jordan',
	},
	{
		code: 'JP',
		name: 'Japan',
	},
	{
		code: 'KE',
		name: 'Kenya',
	},
	{
		code: 'KG',
		name: 'Kyrgyzstan',
	},
	{
		code: 'KH',
		name: 'Cambodia',
	},
	{
		code: 'KI',
		name: 'Kiribati',
	},
	{
		code: 'KM',
		name: 'Comoros',
	},
	{
		code: 'KN',
		name: 'Saint Kitts and Nevis',
	},
	{
		code: 'KP',
		name: 'North Korea',
	},
	{
		code: 'KR',
		name: 'South Korea',
	},
	{
		code: 'KW',
		name: 'Kuwait',
	},
	{
		code: 'KY',
		name: 'Cayman Islands',
	},
	{
		code: 'KZ',
		name: 'Kazakhstan',
	},
	{
		code: 'LA',
		name: 'Laos',
	},
	{
		code: 'LB',
		name: 'Lebanon',
	},
	{
		code: 'LC',
		name: 'Saint Lucia',
	},
	{
		code: 'LI',
		name: 'Liechtenstein',
	},
	{
		code: 'LK',
		name: 'Sri Lanka',
	},
	{
		code: 'LR',
		name: 'Liberia',
	},
	{
		code: 'LS',
		name: 'Lesotho',
	},
	{
		code: 'LT',
		name: 'Lithuania',
	},
	{
		code: 'LU',
		name: 'Luxembourg',
	},
	{
		code: 'LV',
		name: 'Latvia',
	},
	{
		code: 'LY',
		name: 'Libya',
	},
	{
		code: 'MA',
		name: 'Morocco',
	},
	{
		code: 'MC',
		name: 'Monaco',
	},
	{
		code: 'MD',
		name: 'Moldova',
	},
	{
		code: 'ME',
		name: 'Montenegro',
	},
	{
		code: 'MF',
		name: 'Saint Martin',
	},
	{
		code: 'MG',
		name: 'Madagascar',
	},
	{
		code: 'MH',
		name: 'Marshall Islands',
	},
	{
		code: 'MK',
		name: 'North Macedonia',
	},
	{
		code: 'ML',
		name: 'Mali',
	},
	{
		code: 'MM',
		name: 'Myanmar [Burma]',
	},
	{
		code: 'MN',
		name: 'Mongolia',
	},
	{
		code: 'MO',
		name: 'Macao',
	},
	{
		code: 'MP',
		name: 'Northern Mariana Islands',
	},
	{
		code: 'MQ',
		name: 'Martinique',
	},
	{
		code: 'MR',
		name: 'Mauritania',
	},
	{
		code: 'MS',
		name: 'Montserrat',
	},
	{
		code: 'MT',
		name: 'Malta',
	},
	{
		code: 'MU',
		name: 'Mauritius',
	},
	{
		code: 'MV',
		name: 'Maldives',
	},
	{
		code: 'MW',
		name: 'Malawi',
	},
	{
		code: 'MX',
		name: 'Mexico',
	},
	{
		code: 'MY',
		name: 'Malaysia',
	},
	{
		code: 'MZ',
		name: 'Mozambique',
	},
	{
		code: 'NA',
		name: 'Namibia',
	},
	{
		code: 'NC',
		name: 'New Caledonia',
	},
	{
		code: 'NE',
		name: 'Niger',
	},
	{
		code: 'NF',
		name: 'Norfolk Island',
	},
	{
		code: 'NG',
		name: 'Nigeria',
	},
	{
		code: 'NI',
		name: 'Nicaragua',
	},
	{
		code: 'NL',
		name: 'Netherlands',
	},
	{
		code: 'NO',
		name: 'Norway',
	},
	{
		code: 'NP',
		name: 'Nepal',
	},
	{
		code: 'NR',
		name: 'Nauru',
	},
	{
		code: 'NU',
		name: 'Niue',
	},
	{
		code: 'NZ',
		name: 'New Zealand',
	},
	{
		code: 'OM',
		name: 'Oman',
	},
	{
		code: 'PA',
		name: 'Panama',
	},
	{
		code: 'PE',
		name: 'Peru',
	},
	{
		code: 'PF',
		name: 'French Polynesia',
	},
	{
		code: 'PG',
		name: 'Papua New Guinea',
	},
	{
		code: 'PH',
		name: 'Philippines',
	},
	{
		code: 'PK',
		name: 'Pakistan',
	},
	{
		code: 'PL',
		name: 'Poland',
	},
	{
		code: 'PM',
		name: 'Saint Pierre and Miquelon',
	},
	{
		code: 'PN',
		name: 'Pitcairn Islands',
	},
	{
		code: 'PR',
		name: 'Puerto Rico',
	},
	{
		code: 'PS',
		name: 'Palestine',
	},
	{
		code: 'PT',
		name: 'Portugal',
	},
	{
		code: 'PW',
		name: 'Palau',
	},
	{
		code: 'PY',
		name: 'Paraguay',
	},
	{
		code: 'QA',
		name: 'Qatar',
	},
	{
		code: 'RE',
		name: 'Réunion',
	},
	{
		code: 'RO',
		name: 'Romania',
	},
	{
		code: 'RS',
		name: 'Serbia',
	},
	{
		code: 'RU',
		name: 'Russia',
	},
	{
		code: 'RW',
		name: 'Rwanda',
	},
	{
		code: 'SA',
		name: 'Saudi Arabia',
	},
	{
		code: 'SB',
		name: 'Solomon Islands',
	},
	{
		code: 'SC',
		name: 'Seychelles',
	},
	{
		code: 'SD',
		name: 'Sudan',
	},
	{
		code: 'SE',
		name: 'Sweden',
	},
	{
		code: 'SG',
		name: 'Singapore',
	},
	{
		code: 'SH',
		name: 'Saint Helena',
	},
	{
		code: 'SI',
		name: 'Slovenia',
	},
	{
		code: 'SJ',
		name: 'Svalbard and Jan Mayen',
	},
	{
		code: 'SK',
		name: 'Slovakia',
	},
	{
		code: 'SL',
		name: 'Sierra Leone',
	},
	{
		code: 'SM',
		name: 'San Marino',
	},
	{
		code: 'SN',
		name: 'Senegal',
	},
	{
		code: 'SO',
		name: 'Somalia',
	},
	{
		code: 'SR',
		name: 'Suriname',
	},
	{
		code: 'SS',
		name: 'South Sudan',
	},
	{
		code: 'ST',
		name: 'São Tomé and Príncipe',
	},
	{
		code: 'SV',
		name: 'El Salvador',
	},
	{
		code: 'SX',
		name: 'Sint Maarten',
	},
	{
		code: 'SY',
		name: 'Syria',
	},
	{
		code: 'SZ',
		name: 'Swaziland',
	},
	{
		code: 'TC',
		name: 'Turks and Caicos Islands',
	},
	{
		code: 'TD',
		name: 'Chad',
	},
	{
		code: 'TF',
		name: 'French Southern Territories',
	},
	{
		code: 'TG',
		name: 'Togo',
	},
	{
		code: 'TH',
		name: 'Thailand',
	},
	{
		code: 'TJ',
		name: 'Tajikistan',
	},
	{
		code: 'TK',
		name: 'Tokelau',
	},
	{
		code: 'TL',
		name: 'East Timor',
	},
	{
		code: 'TM',
		name: 'Turkmenistan',
	},
	{
		code: 'TN',
		name: 'Tunisia',
	},
	{
		code: 'TO',
		name: 'Tonga',
	},
	{
		code: 'TR',
		name: 'Turkey',
	},
	{
		code: 'TT',
		name: 'Trinidad and Tobago',
	},
	{
		code: 'TV',
		name: 'Tuvalu',
	},
	{
		code: 'TW',
		name: 'Taiwan',
	},
	{
		code: 'TZ',
		name: 'Tanzania',
	},
	{
		code: 'UA',
		name: 'Ukraine',
	},
	{
		code: 'UG',
		name: 'Uganda',
	},
	{
		code: 'UM',
		name: 'U.S. Minor Outlying Islands',
	},
	{
		code: 'US',
		name: 'United States',
	},
	{
		code: 'UY',
		name: 'Uruguay',
	},
	{
		code: 'UZ',
		name: 'Uzbekistan',
	},
	{
		code: 'VA',
		name: 'Vatican City',
	},
	{
		code: 'VE',
		name: 'Venezuela',
	},
	{
		code: 'VG',
		name: 'British Virgin Islands',
	},
	{
		code: 'VI',
		name: 'U.S. Virgin Islands',
	},
	{
		code: 'VN',
		name: 'Vietnam',
	},
	{
		code: 'VU',
		name: 'Vanuatu',
	},
	{
		code: 'WF',
		name: 'Wallis and Futuna',
	},
	{
		code: 'WS',
		name: 'Samoa',
	},
	{
		code: 'XK',
		name: 'Kosovo',
	},
	{
		code: 'YE',
		name: 'Yemen',
	},
	{
		code: 'YT',
		name: 'Mayotte',
	},
	{
		code: 'ZA',
		name: 'South Africa',
	},
	{
		code: 'ZM',
		name: 'Zambia',
	},
	{
		code: 'ZW',
		name: 'Zimbabwe',
	},
];
